import { IconButton } from 'component/Button'
import { Space } from 'component/Space'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { FiltersPanel } from 'page/catalog/DemoCatalogFilters/FiltersPanel'
import { MobileFilters } from 'page/catalog/DemoCatalogFilters/MobileFilters'
import { GendersPanel } from 'page/catalog/GendersPanel/GendersPanel'
import { SearchField } from 'page/catalog/SearchField/SearchField'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { ui } from 'store/home/ui/HomeUiStore'

export const DemoCatalogFilters = observer(() => {
  const { tablet } = ui.window
  const demo = useDemo()
  const { options, search_open } = demo
  const { ready, genders } = options
  const { search } = demo.product

  const onOpen = useLatestCallback(() => {
    demo.search_open = !demo.search_open
  })

  if (!ready && !search) return null

  if (!ready) return <Space center>{search && <SearchField />}</Space>

  if (tablet) return (
    <Vertical gap={8}>
      {(genders || search) && (
        <Space gap={8} wide>
          {genders && <GendersPanel />}
          {search && <IconButton large panel action={onOpen}>
            <Icon size={16} name={search_open ? 'keyboard_arrow_up' : 'search'} />
          </IconButton>}
        </Space>
      )}
      {search && search_open && (
        <Space flex="1 1 auto">
          <SearchField />
        </Space>
      )}
      <MobileFilters />
    </Vertical>
  )

  return (
    <Vertical gap={8}>
      {(genders || search) && (
        <Space gap={16} wide wrap center>
          {genders && <GendersPanel />}
          {search && (
            <Space flex="1 1 auto">
              <SearchField />
            </Space>
          )}
        </Space>
      )}
      <FiltersPanel />
    </Vertical>
  )
})
